import { render, staticRenderFns } from "./footer-white.vue?vue&type=template&id=3b9debb8&"
import script from "./footer-white.vue?vue&type=script&lang=js&"
export * from "./footer-white.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports